import VueCookie from 'vue-cookie'
import AuthUser from './auth/user.js'
import Setting from './setting.js'
import Cart from './cart.js'

import Vue from 'vue'
const moment = require('moment')
import Core from "./index";
Vue.use(require('vue-moment'), {
    moment
})

export default {
    isInitialized: false,
    AuthUser: AuthUser,
    Setting: Setting,
    Cart: Cart,
    subDomain: '',
    domain: '',
    branchId: '',
    branch: {},
    environmentId: '',
    environment: {
        name :'',
        status: ''
    },
    branches: [],
    environments: [],
    paymentGateway: {
        terminal: '',
        tokenizationCallUrl: ''
    },
    googleClient: {
        applicationId: '',
        authURL: ''
    },
    binders: [],
    isWidget: false,
    isSubEnvironment() {
        if (Core.Validation.isId(this.environmentId)||this.subDomain !== '') {
            return true;
        }
        return false
    },
    isPrimaryBranch() {
        if (Core.Validation.isId(this.branch.id)) {
            if (this.branch.isPrimary !== undefined) {
                let isPrimary = this.branch.isPrimary
                isPrimary = Core.Value.encode(this.branch.isPrimary, Core.Value.typeBool)
                return isPrimary
            }
        }
        return false
    },
    retrieve(){
        this.branchId = VueCookie.get('SessionBranchId')
        if (!Core.Validation.isId(this.branchId)) {
            this.branchId = ''
        }

        let subDomain = this.getSubDomain()
        if (subDomain) {
            this.subDomain = subDomain
        }

        let domain = this.getDomain()
        if (domain) {
            this.domain = domain
        }
    },
    set(session) {

        if(session.binders !== undefined) {
            this.binders = session.binders
        }

        if(session.settings !== undefined) {
            this.Setting.settings = session.settings

            if (session.settings.environment !== undefined && session.settings.environment.ui !== undefined) {
                if (session.settings.environment.ui.theme !== undefined && session.settings.environment.ui.theme === Core.Theme.themeCustom) {
                    Core.Theme.resetStyle()
                    if (session.settings.environment.ui.customStyles !== undefined) {
                        let styles = session.settings.environment.ui.customStyles
                        styles = JSON.parse(styles)
                        Core.Theme.customStyle = styles
                        Core.Theme.buildSheet(Core.Theme.prepareCustomStyles())
                    }
                }
            }
        }

        if(session.googleClient !== undefined) {
            this.googleClient = session.googleClient
        }

        if(session.lang !== undefined) {
            this.Setting.setSetting('lang', session.lang)
        }

        if(session.branch !== undefined) {
            this.branch = session.branch

            if (session.branch.id !== undefined) {
                this.branchId = session.branch.id
            }
        }

        if(session.environment !== undefined) {
            this.environment = session.environment

            if (!this.isWidget) {

                if (this.branch.name!==undefined && this.branch.name !== '') {
                    document.title = this.branch.name
                }

                let environmentUIFavicon = Core.Setting.getSetting('environment.ui.logoFavicon')
                if (environmentUIFavicon !== '') {
                    let link = document.querySelector("link[rel~='icon']");
                    if (!link) {
                        link = document.createElement('link');
                        link.rel = 'icon';
                        document.getElementsByTagName('head')[0].appendChild(link);
                    }
                    link.href = environmentUIFavicon;
                }

            }

            if (session.environment.id !== undefined) {
                this.environmentId = session.environment.id
            }
        }

        if(session.branches !== undefined) {
            this.branches = session.branches
        }

        if(session.subDomain !== undefined) {
            this.subDomain = session.subDomain
        }

        if(session.domain !== undefined) {
            this.domain = session.domain
        }

        if(session.authUser !== undefined) {
            if (session.authUser.hasOrders!==undefined) {
                this.AuthUser.hasOrders = session.authUser.hasOrders
            }
            if (session.authUser.hasLimitedSubscriptions!==undefined) {
                this.AuthUser.hasLimitedSubscriptions = session.authUser.hasLimitedSubscriptions
            }
            if (session.authUser.hasRecurringSubscriptions!==undefined) {
                this.AuthUser.hasRecurringSubscriptions = session.authUser.hasRecurringSubscriptions
            }
            if (session.authUser.id!==undefined) {
                this.AuthUser.id = session.authUser.id
            }
            if (session.authUser.firstname!==undefined) {
                this.AuthUser.firstname = session.authUser.firstname
            }
            if (session.authUser.lastname!==undefined) {
                this.AuthUser.lastname = session.authUser.lastname
            }
            if (session.authUser.displayName!==undefined) {
                this.AuthUser.displayName = session.authUser.displayName
            }
            if (session.authUser.avatar!==undefined) {
                this.AuthUser.avatar = session.authUser.avatar
            }
            if (session.authUser.email!==undefined&&session.authUser.signature!==undefined&&session.authUser.caps!==undefined) {
                this.AuthUser.email = session.authUser.email
                this.AuthUser.signature = session.authUser.signature
                this.AuthUser.caps = session.authUser.caps
            } else {
                this.reset()
                this.AuthUser.reset()
            }
        }
        this.setCookies()
        this.AuthUser.setCookies()

        if(session.paymentGateway !== undefined) {
            this.paymentGateway = session.paymentGateway
        }

        if (session.lang !== undefined) {
            if (session.lang.toLowerCase()!=='en-us') {
                require('moment/locale/' + session.lang.toLowerCase())
            }
        } else {
            require('moment/locale/fr')
        }

        this.isInitialized = true
    },
    reset() {
        this.branchId = ''
        this.branch = {}
        Core.Theme.customStyle = false
    },
    setCookies() {
        VueCookie.set('SessionBranchId', this.branchId, {expires: 99, SameSite: 'None'})
        VueCookie.set('SessionBranchLogoLoading', Core.Setting.getSetting('environment.ui.logoLoading'), {expires: 99, SameSite: 'None'})

        Core.Session.setValue('SessionBranchLogoLoading', Core.Setting.getSetting('environment.ui.logoLoading'))
        Core.Session.setValue('SessionBranchLogoFavicon', Core.Setting.getSetting('environment.ui.logoFavicon'))
        Core.Session.setValue('SessionBranchLogoLoadingWidth', Core.Setting.getSetting('environment.ui.logoLoadingWidth'))
        Core.Session.setValue('SessionBranchLogoLoadingAnimationClass', Core.Setting.getSetting('environment.ui.logoLoadingAnimationClass'))

        //VueCookie.set('SessionUICustomStyles',  JSON.stringify(Core.Theme.customStyle), {expires: 99, SameSite: 'None'})
    },
    logOut() {
        this.reset()
        this.AuthUser.reset()
        this.AuthUser.setCookies()
        this.setCookies()
    },
    getSubDomain() {
        let subdomain = window.location.hostname.split('.')
        if (undefined !== subdomain && subdomain[0] !== 'localhost' && subdomain[0] !== 'app') {
            return subdomain[0]
        }
        return false
    },
    getDomain() {
        let domain = window.location.hostname.split('.')
        if (undefined !== domain[1] && domain[2] !== undefined) {
            return domain[1] + '.' + domain[2]
        }
        return false
    },
    isApp() {
        let subdomain = window.location.hostname.split('.')
        if (undefined !== subdomain && subdomain[0] !== 'localhost' && subdomain[0] !== 'app' && subdomain[0] !== 'beta') {
            return false
        }
        return true
    },
    setValue(storageKey, value) {
        localStorage.setItem(storageKey, value)
    },
    getValue(storageKey, settingKey, appSettingKey) {
        let storageValue = localStorage.getItem(storageKey)
        if (storageValue !== undefined && storageValue !== '' && storageValue !== 'undefined') {
            return storageValue
        } else {
            if (this.isApp()&&appSettingKey!==undefined) {
                return Core.Setting.getSetting(appSettingKey)
            } else {
                if (settingKey!==undefined) {
                    return Core.Setting.getSetting(settingKey)
                }
            }
        }
        return false
    },
    hasBinder(slug) {
        let binders = this.binders
        for(let binderIndex in binders) {
            let binder = binders[binderIndex]
            if (binder.slug === slug) {
                return binderIndex
            }
        }
        return false
    }
}